import FitModeller from '../../src/main';
import './overrides.scss';

import WelcomePage from './views/WelcomePage.vue';
import HeaderFyF from './views/HeaderFyF.vue';
import ResultsPage from './views/ResultsPage.vue';
import store from './config';

new FitModeller({
  vueOptions: {
    store
  },
  components: {
    WelcomePage,
    HeaderFyF,
    ResultsPage
  },
}).init('#app');
